import daysjs from 'dayjs';
import relativeTime from 'dayjs/plugin/relativeTime';

const timeFromNow = (date) => {
    daysjs.extend(relativeTime);
    return daysjs(date).fromNow();
}

export default timeFromNow;